import { Link } from 'react-router-dom'
import { Container } from '../ui/Container'
import {
  contactDetails,
  footerCompanyLinks,
  footerIndustryLinks,
  footerProductLinks,
  footerServiceLinks,
  socialLinks,
} from '../../data/nav'

function FooterColumn({ title, links }: { title: string; links: readonly { label: string; href: string }[] }) {
  return (
    <div>
      <p className="text-xs font-medium uppercase tracking-[0.2em] text-stone">{title}</p>
      <ul className="mt-5 flex flex-col gap-3">
        {links.map((link) => (
          <li key={link.href}>
            <Link to={link.href} className="text-sm text-snow/80 transition-colors hover:text-snow">
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export function Footer() {
  return (
    <footer className="bg-night text-snow">
      <Container className="py-20">
        <div className="grid grid-cols-2 gap-12 md:grid-cols-6">
          <div className="col-span-2">
            <Link to="/" aria-label="Limitlast home">
              <img
                src="/limitlast-footer.svg"
                alt="Limitlast — Beyond Limits. Built to Last."
                width={500}
                height={500}
                className="h-30 w-auto md:h-32"
              />
            </Link>
            <p className="mt-6 max-w-xs text-sm text-snow/70">We build what businesses need next.</p>

            <div className="mt-8 flex flex-col gap-2 text-sm text-snow/80">
              <a href={`mailto:${contactDetails.email}`} className="w-fit hover:text-signal">
                {contactDetails.email}
              </a>
              {contactDetails.phones.map((phone) => (
                <a
                  key={phone}
                  href={`tel:${phone.replace(/[^+\d]/g, '')}`}
                  className="w-fit hover:text-signal"
                >
                  {phone}
                </a>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-x-4 gap-y-2">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Limitlast on ${social.label} (opens in a new tab)`}
                  className="text-sm text-snow/70 hover:text-snow"
                >
                  {social.label}
                </a>
              ))}
            </div>
          </div>

          <FooterColumn title="Services" links={footerServiceLinks} />
          <FooterColumn title="Industries" links={footerIndustryLinks} />
          <FooterColumn title="Products" links={footerProductLinks} />
          <FooterColumn title="Company" links={footerCompanyLinks} />
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-snow/10 pt-8 text-xs text-snow/60 md:flex-row md:items-center md:justify-between">
          <p>Built from The Gambia. Working beyond borders.</p>
          <p>© {new Date().getFullYear()} Limitlast. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  )
}
